import { LogTimeline } from '../../../../components/generic'
import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'

export default withToolbar(LogTimeline, {
  dateFilter: {
    left: true,
  },
  disableMock: true,
  timeWindow: 7 * 4,
  pdfExport: {
    title: chartTitles.activity_social,
    headerDate: false,
    groupBy: 'date',
    dateFormat: 'HH:mm',
  },
})
